/**
 * §10.6 Engineering Philosophy — 7 pillars.
 */

import React from 'react'
import {
  Bot, Boxes, GitBranch, ShieldCheck, Layers, Gauge, HeartHandshake, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { ENG_PHILOSOPHY } from '../data'

const ICONS = { Bot, Boxes, GitBranch, ShieldCheck, Layers, Gauge, HeartHandshake, Sparkles }

export default function Engineering() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Engineering Philosophy</Eyebrow>
          <SectionHeading align="center"
            title={<>How the platform{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">is engineered.</span></>}
            subtitle="Seven pillars that make Kalki Ai Cloud feel calm under scale.  We don&apos;t leak internal implementation details — these are the principles our teams operate by."
          />
        </div>
        <FeatureGrid items={ENG_PHILOSOPHY} icons={ICONS} cols={4} />
      </Container>
    </section>
  )
}
